// extracted by mini-css-extract-plugin
export default {"tooltip":"_n-z","sharingV2":"ao-z","sharingIconsV2":"bo-z","links":"co-z","link":"do-z","facebookV2":"eo-z","twitterV2":"fo-z","pinterestV2":"go-z"};